module.exports = __webpack_public_path__ + "img/6.ed945f8d.jpg";